// 前后端统一校验规则（唯一规则源：woofootball_api/doc/login-validation.md）
// 后端 PHP Validate（app/site/validate/LoginValidate.php、UserValidate.php）与本文件必须保持一致。
// 2026-09-07（ADR-0041）：去用户名化——登录标识仅为邮箱，用户名校验已移除。

/** 邮箱：标准格式，最长 100 */
export const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/

/** 验证码：6 位数字 */
export const CODE_REGEX = /^\d{6}$/

/** 明文密码（提交前先 AES 加密）：8~20 位，含大写+小写+数字，无空格 */
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])\S{8,20}$/

export const EMAIL_MAX = 100
export const PASSWORD_MIN = 8
export const PASSWORD_MAX = 20
export const NICKNAME_MAX = 30

export interface FieldError {
  valid: boolean
  message: string
}

export function checkEmail(value: string): FieldError {
  if (!value) return { valid: false, message: 'validation.emailRequired' }
  if (value.length > EMAIL_MAX) return { valid: false, message: 'validation.emailMax' }
  if (!EMAIL_REGEX.test(value)) return { valid: false, message: 'validation.emailFormat' }
  return { valid: true, message: '' }
}

export function checkPassword(value: string): FieldError {
  if (!value) return { valid: false, message: 'validation.passwordRequired' }
  if (!PASSWORD_REGEX.test(value)) return { valid: false, message: 'validation.passwordFormat' }
  return { valid: true, message: '' }
}

/** 密码强度逐项检查（注册/改密强度提示用，与 checkPassword 同源规则） */
export function getPasswordRuleStatus(value: string): { key: string; ok: boolean }[] {
  return [
    { key: 'passwordLength', ok: value.length >= PASSWORD_MIN && value.length <= PASSWORD_MAX },
    { key: 'passwordLower', ok: /[a-z]/.test(value) },
    { key: 'passwordUpper', ok: /[A-Z]/.test(value) },
    { key: 'passwordDigit', ok: /[0-9]/.test(value) },
    { key: 'passwordSpace', ok: !/\s/.test(value) }
  ]
}

export function checkCode(value: string): FieldError {
  if (!value) return { valid: false, message: 'validation.codeRequired' }
  if (!CODE_REGEX.test(value)) return { valid: false, message: 'validation.codeFormat' }
  return { valid: true, message: '' }
}

export function checkNickname(value: string): FieldError {
  if (!value) return { valid: false, message: 'validation.nameRequired' }
  const len = [...value].length // 按码点计（中英文都算 1 个字符，与后端 mb_strlen 对齐）
  if (len > NICKNAME_MAX) return { valid: false, message: 'validation.nameMax' }
  return { valid: true, message: '' }
}
